import { PercentBox } from "../styles/BoxingStyles";
import { OrderBar } from "../styles/ChangeHeader";
import {CFlexBetween, ColorText, FlexBetween, FlexCenter, TradeWrapper} from "../styles/CommonStyles";
import Text from "../utils/Text";
import Loading from "./common/loading/Loading";
import {useOrderPercentage} from "../hooks/useTradeHeaderHook";


const OrdersPercentage = () => {

    const {
        ordersAmount
    } = useOrderPercentage()

    return (
        <PercentBox>
            {
                <TradeWrapper padding="20px 20px 0 20px">
                    <OrdersPercentBars ordersAmount={ordersAmount} />
                </TradeWrapper>
            }
            <Loading loading={ordersAmount.bl && ordersAmount.sl} />
        </PercentBox>
    )
}


export const OrdersPercentBars = ({ordersAmount}) => {

    return (
        <CFlexBetween>
            <FlexCenter width="100%" height="8px">
                <OrderBar
                    width={Math.ceil(
                        (ordersAmount.buy / (ordersAmount.buy + ordersAmount.sell)) * 100
                    )}
                    type="buy"
                />
                <OrderBar
                    width={Math.floor(
                        (ordersAmount.sell / (ordersAmount.sell + ordersAmount.buy)) * 100
                    )}
                    type="sell"
                />
            </FlexCenter>
            <FlexBetween>
                <ColorText tradeType="buy">
                    <Text tid="buy" />
                    {" "}
                    %
                    {Math.ceil(
                        (ordersAmount.buy / (ordersAmount.buy + ordersAmount.sell)) * 100 ?
                            (ordersAmount.buy / (ordersAmount.buy + ordersAmount.sell)) * 100 : 0
                    )}
                </ColorText>
                <ColorText tradeType="sell">
                    <Text tid="sell" />
                    {" "}
                    %
                    {Math.floor(
                        (ordersAmount.sell / (ordersAmount.sell + ordersAmount.buy)) * 100 ?
                            (ordersAmount.sell / (ordersAmount.sell + ordersAmount.buy)) * 100 : 0
                    )}

                </ColorText>
            </FlexBetween>
        </CFlexBetween>
    )
}


export default OrdersPercentage;
